import moment from "moment";

/** Given an endTime in integer format convert it to number of seconds from now (which corresponds to classexpiry) */
export const convertEndTimeToSecsTillExpiry = (endTimeInt) => {
	const currentDateTime = new Date();
	const currentMinute = currentDateTime.getMinutes();
	const currentHour = currentDateTime.getHours();

	const endTimeHour = Math.floor(endTimeInt / 100);
	const endTimeMinute = endTimeInt % 100;

	const converted = (endTimeHour - currentHour) * 3600 + (endTimeMinute - currentMinute) * 60;
	return converted;
};

export const timeInputAutoInsertColon = (inputStr) => {
	if (inputStr.length === 2 && /\d{2}/.test(inputStr)) {
		inputStr += ":";
	}
	return inputStr;
};

export const generateClassExpiryStr = (expiry, verbose = false, isMonitoring = false) => {
	if (!expiry) return null;

	const unixMoment = moment.unix(expiry);

	let meridianTime = unixMoment.format("LT");
	if (meridianTime[1] === ":") {
		meridianTime = "0" + meridianTime;
	}
	return verbose ? `${!isMonitoring ? "Class" : "Monitoring"} until ${meridianTime}` : meridianTime;
};

/**
 * Iterates through a list of periods, returns the first matching schedule if found, otherwise returns null.
 * @param {array} periods array of period objects
 * @returns {number} class expiry in unix format (seconds since epoch)
 */
export const findUnixExpiryFromPeriods = (periods) => {
	if (periods) {
		const DAYS_LOOKUP = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];

		for (const period of periods) {
			const now = moment();
			const momentDay = now.day();

			if (period.day === DAYS_LOOKUP[momentDay]) {
				const now24hour = now.format("HHmm");
				if (now24hour >= period.startTime && now24hour < period.endTime) {
					const endTimeStr = period.endTime.toString().padStart(4, "0");
					const expiryUnix = moment({
						hour: endTimeStr.slice(0, 2),
						minute: endTimeStr.slice(2),
					}).unix();
					return expiryUnix;
				}
			}
		}
	}
	return null;
};
